import { render } from "./SmartPagination.vue?vue&type=template&id=f8c31f12&scoped=true"
import script from "./SmartPagination.vue?vue&type=script&lang=js"
export * from "./SmartPagination.vue?vue&type=script&lang=js"

import "./SmartPagination.vue?vue&type=style&index=0&id=f8c31f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c31f12"]])

export default __exports__